import { Component } from "../core/Component";
import { GameObject } from "../core/GameObject";
import ArrayUtils from "../utils/ArrayUtils";

// holds a free-floating spine object and makes its position match its game object's position.
// when the game object is added to a layer via GameLayers.addObject, the spine is automatically added to the corresponding spine container.

// make sure to add this component after the planck body component so the spine updates as soon as the object moves.
export class SpineAnimation extends Component {
	spine: SpineGameObject;
	key: string;
	ox = 0;
	oy = 0;
	// set to false if you want the spine to stick around on destroy (like if the object is pooled)
	autoDestroySpine: boolean;
	
	constructor(obj: GameObject, spine: SpineGameObject, key: string, autoDestroySpine: boolean, ox = 0, oy = 0) {
		super(obj);
		this.spine = spine;
		obj.attachments.push(spine);
		this.key = key;
		this.autoDestroySpine = autoDestroySpine;
		this.spine.setData("spineKey", key);
		this.ox = ox;
		this.oy = oy;
	}

	public destroy(): void {
		ArrayUtils.remove(this.obj.attachments, this.spine);
		if (this.autoDestroySpine) this.spine.destroy();
		super.destroy();
	}

	public update(_dt: number): void {
		this.spine.x = this.obj.x + this.ox;
		this.spine.y = this.obj.y + this.oy;
	}

	public physicsUpdate(_dt: number): void {
		this.spine.x = this.obj.x + this.ox;
		this.spine.y = this.obj.y + this.oy;
	}
}